/**
 * RequireAuth - route guard that redirects to /login when not authenticated.
 * Use as a layout route parent of PracticeLayout so all clinical routes are protected.
 */
import { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "@/providers/auth-context";
import { LoadingSpinner } from "@/components/shared/loading-spinner";

export function RequireAuth() {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (auth?.isLoading) return;
    if (!auth?.isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [auth?.isLoading, auth?.isAuthenticated, navigate]);

  if (auth?.isLoading) {
    return <LoadingSpinner fullPage message="Checking session…" />;
  }

  if (!auth?.isAuthenticated) {
    return null;
  }

  return <Outlet />;
}
